var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcEnableCouponDownload = function SvgIcEnableCouponDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D80C18",
    fillRule: "evenodd",
    d: "M1.1 20.3c0-.608.448-1.1 1-1.1H19.9c.552 0 1 .492 1 1.1 0 .607-.448 1.1-1 1.1H2.1c-.553 0-1.001-.492-1.001-1.1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80C18",
    d: "M9.955 3.407a1.048 1.048 0 1 1 2.095 0v12.564a1.048 1.048 0 1 1-2.095 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80C18",
    fillRule: "evenodd",
    d: "M4.436 10.457c.41-.41 1.073-.41 1.482 0l5.08 5.08 5.08-5.08a1.048 1.048 0 1 1 1.482 1.481l-5.82 5.821a1.05 1.05 0 0 1-1.482 0l-5.822-5.82a1.05 1.05 0 0 1 0-1.482",
    clipRule: "evenodd"
  })));
};
export default SvgIcEnableCouponDownload;